import eventsService from './eventsService'

export default eventsService



// WEBPACK FOOTER //
// ../src/services/eventsService/index.js